<div class="w-full">
  <precredit-input
    [label]="label()"
    [control]="control"
    [placeholder]="rule()?.example || 'Ingresar'"
    [showError]="false"
    type="text"
  ></precredit-input>

  @if (!hasError() && helperText()) {
    <p class="font-poppins font-normal text-[12px] mt-1 ml-3 text-text-secondary">
      {{ helperText() }}
    </p>
  }

  @if (hasError()) {
    <div class="flex items-center ml-3 mt-1">
      <i class="fi fi-sr-triangle-warning text-negative mr-1 text-[13px] flex-shrink-0 h-4 flex"></i>
      <p class="font-poppins font-normal text-[12px] text-start leading-tight text-[#B1000F]">
        {{ errorMessage() }}
      </p>
    </div>
  }
</div>
